import { Button } from '@shared/components/ui/button';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface CreateWithdrawalButtonProps {
  onClick: () => void;
}

export const CreateWithdrawalButton = ({ onClick }: CreateWithdrawalButtonProps) => {
  const { t } = useTranslation('withdrawalsModule');

  return (
    <Button variant="primary" size="default" onClick={onClick} data-testid="create-withdrawal-button">
      <FontAwesomeIcon icon={faPlus} className="w-4 h-4 mr-2" />
      {t('buttons.create')}
    </Button>
  );
};
